import { MATHEMATICS_REGEX } from "@knowt/editor/extensions/mathematics";
import katex from "katex";
import { decodeHtmlEntities } from "./decodeHtmlEntities";

export const renderLatexToString = (inputString: string) => {
    return inputString.replace(MATHEMATICS_REGEX, (_, latexContent) => {
        try {
            // incase latex is copied from a webpage where the LaTeX was stored in HTML format, we must decode it
            const decodedLatex = decodeHtmlEntities(latexContent);
            return katex.renderToString(decodedLatex);
        } catch {
            return latexContent;
        }
    });
};
